import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiClient } from '@/lib/api-client'
import { Loader2 } from 'lucide-react'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    // Verificação síncrona e rápida - sem timeout necessário
    console.log('[AUTH_GUARD] Checking authentication...')
    const token = apiClient.getToken()
    console.log('[AUTH_GUARD] Token exists:', !!token)
    
    if (!apiClient.isAuthenticated()) {
      console.log('[AUTH_GUARD] Not authenticated, redirecting to login')
      navigate('/login')
      setIsLoading(false)
    } else {
      console.log('[AUTH_GUARD] Authenticated, rendering children')
      setIsAuthenticated(true)
      setIsLoading(false)
    }
  }, [navigate])

  if (isLoading) {
    return (
      <div className="fixed inset-0 w-screen h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-purple-400 mx-auto mb-4" />
          <p className="text-purple-300 text-sm">Carregando...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  return <>{children}</>
}
